import { useMatch } from "react-router-dom-v5-compat";

export const useBanParam = () => {
  const match = useMatch("billing/customer/:ban/*");
  return match?.params.ban || "";
};
